import { api } from './client'

export const listRecipients = (pid, filter = {}) => {
  const params = {}
  if (filter.courseId) params.courseId = filter.courseId
  if (filter.certEligible) params.certEligible = 'true'
  return api.get(`/emails/programs/${pid}/recipients`, { params }).then((r) => r.data)
}

export const sendEmailToUsers = (pid, payload) =>
  api.post(`/emails/programs/${pid}/send`, payload).then((r) => r.data)

export const sendBroadcastEmail = (pid, payload) =>
  api.post(`/emails/programs/${pid}/broadcast`, payload).then((r) => r.data)

export const sendSessionReminder = (pid, sessionId) =>
  api.post(`/emails/programs/${pid}/session-reminder/${sessionId}`).then((r) => r.data)

export const listEmailLogs = (pid, limit = 100) =>
  api.get(`/emails/programs/${pid}/logs`, { params: { limit } }).then((r) => r.data)
